/** Keydown handler for dropdown menu containers: ESC closes, arrows navigate between items, left/right blocked */
export function menuKeyDown(closeMenu: () => void): (ev: React.KeyboardEvent) => void {
  return (ev: React.KeyboardEvent) => {
    if (ev.key == 'Escape') {
      ev.preventDefault();
      ev.stopPropagation();
      const trigger = (ev.currentTarget as HTMLElement).previousElementSibling as HTMLElement;
      closeMenu();
      trigger?.focus();
      return;
    }
    if (ev.key == 'ArrowLeft' || ev.key == 'ArrowRight') {
      ev.preventDefault();
      ev.stopPropagation();
      return;
    }
    const container = ev.currentTarget as HTMLElement;
    const items = Array.from(container.querySelectorAll<HTMLElement>('.flowFocussable:not(:disabled)'));
    const idx = items.indexOf(document.activeElement as HTMLElement);
    if (ev.key == 'ArrowDown') {
      ev.preventDefault();
      ev.stopPropagation();
      items[idx + 1]?.focus();
    } else if (ev.key == 'ArrowUp') {
      ev.preventDefault();
      ev.stopPropagation();
      items[idx - 1]?.focus();
    }
  };
}

/** Blur handler for dropdown menus: close when focus leaves the container */
export function menuBlur(closeMenu: () => void): (ev: React.FocusEvent) => void {
  return (ev: React.FocusEvent) => {
    const container = ev.currentTarget as HTMLElement;
    if (!container.contains(ev.relatedTarget as Node))
      closeMenu();
  };
}
